<div class="skeleton-header mt-2 mb-3"></div>
<div class="carousel-skeleton">
    @for (item of items(); track item; let idx = $index) {
      <div class="skeleton-card clip4" [style.width]="cardWidth()" [style.animationDelay]="idx * 0.3 + 's'">
      </div>
    }
  </div>
  